import {Link} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import cn from 'classnames';
import _ from 'lodash';

import {toCollectionId} from '../../config/routes';
import {collections, collectionsVariables} from '../../shared/graphql/__generated__/collections';
import {QUERY_COLLECTIONS} from '../../shared/graphql/collection';

import cls from './CollectionSelect.module.scss';

export const CollectionSelect = () => {
    const collections = useQuery<collections,collectionsVariables>(QUERY_COLLECTIONS, {
        variables: {
            filters: {
                enabled: {eq: true},
            },
        }
    })

    return (
        <div className={cls.collections}>
            {_.map(collections.data?.collections, item => (
                <Link key={item?.documentId} to={toCollectionId(item?.documentId!)}
                      className={cn([cls.menu])}>{item?.name}</Link>
            ))}
        </div>
    )
}